import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 14l11 -11","key":"svg-0"}],["path",{"d":"M10 3h4v4","key":"svg-1"}],["path",{"d":"M10 17v4h4","key":"svg-2"}],["path",{"d":"M21 10l-11 11","key":"svg-3"}]]

const IconArrowsDoubleNeSw = createReactComponent('outline', 'arrows-double-ne-sw', 'ArrowsDoubleNeSw', __iconNode);

export default IconArrowsDoubleNeSw;